export default __webpack_public_path__ + "static/media/menuBtn.a317dc45.webp";